import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Button from '@material-ui/core/Button';
import portfolio61 from '../static/img/portfolio6-1.png';
import portfolio62 from '../static/img/portfolio6-2.png';
import portfolio63 from '../static/img/portfolio6-3.png';
import portfolio64 from '../static/img/portfolio6-4.png';
import portfolio65 from '../static/img/portfolio6-5.png';
import portfolio66 from '../static/img/portfolio6-6.png';
import portfolio67 from '../static/img/portfolio6-7.png';
import portfolio68 from '../static/img/portfolio6-8.png';
import portfolio69 from '../static/img/portfolio6-9.png';
import portfolio610 from '../static/img/portfolio6-10.png';
import portfolio60 from '../static/img/portfolio6-0.png';
import portfolio71 from '../static/img/portfolio7-1.png';
import portfolio72 from '../static/img/portfolio7-2.png';
import portfolio73 from '../static/img/portfolio7-3.png';
import portfolio74 from '../static/img/portfolio7-4.png';
import portfolio75 from '../static/img/portfolio7-5.png';
import portfolio76 from '../static/img/portfolio7-6.png';
import portfolio77 from '../static/img/portfolio7-7.png';
import portfolio81 from '../static/img/portfolio8-1.png';
import portfolio82 from '../static/img/portfolio8-2.png';
import portfolio83 from '../static/img/portfolio8-3.png';
import portfolio84 from '../static/img/portfolio8-4.png';
import portfolio85 from '../static/img/portfolio8-5.png';
import portfolio86 from '../static/img/portfolio8-6.png';
import portfolio80 from '../static/img/portfolio8-0.png';
import portfolio90 from '../static/img/portfolio9.png';
import portfolio92 from '../static/img/portfolio9-2.png';
import portfolio91 from '../static/img/portfolio9-1.png';
import portfolio93 from '../static/img/portfolio9-3.png';
import portfolio94 from '../static/img/portfolio9-4.png';
import portfolio95 from '../static/img/portfolio9-5.png';
import portfolio96 from '../static/img/portfolio9-6.png';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, EffectFade } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/scrollbar/scrollbar.scss';
import 'swiper/components/effect-fade/effect-fade.scss';
//import Carousel from 'react-material-ui-carousel'; //no need
import { Paper } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	modal: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '80%',
		margin: '0 auto'
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3)
	}
}));
SwiperCore.use([ Navigation, Pagination, Scrollbar, A11y, EffectFade ]);

const PortfolioModal = ({ imgTitle }) => {
	const classes = useStyles();
	const [ open, setOpen ] = React.useState(false);

	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const detectIdiomImages = [
		portfolio60,
		portfolio61,
		portfolio62,
		portfolio63,
		portfolio64,
		portfolio65,
		portfolio66,
		portfolio67,
		portfolio68,
		portfolio69,
		portfolio610
	];
	const chatbotImages = [ portfolio71, portfolio72, portfolio73, portfolio74, portfolio75, portfolio76, portfolio77 ];
	const styleAiImages = [ portfolio80, portfolio81, portfolio82, portfolio83, portfolio84, portfolio85, portfolio86 ];
	const annazonImages = [ portfolio90, portfolio91, portfolio92, portfolio93, portfolio94, portfolio95, portfolio96 ];
	const [ images, setImages ] = useState(detectIdiomImages);
	useEffect(
		() => {
			switch (imgTitle) {
				case 'detectIdiom':
					setImages(detectIdiomImages);
					break;
				case 'chatbot':
					setImages(chatbotImages);
					break;
				case 'styleAi':
					setImages(styleAiImages);
					break;
				case 'annazon':
					setImages(annazonImages);
					break;
				default:
					setImages(detectIdiomImages);
			}
		},
		[ imgTitle ]
	);
	const Item = (props) => {
		return (
			<Paper>
				<img src={props.image} alt="portfolio-image" style={{ width: '100%' }} />
			</Paper>
		);
	};

	return (
		<div className="ml-auto d-inline">
			<Button onClick={handleOpen} color="secondary">
				Screenshots
			</Button>
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className={classes.modal}
				open={open}
				onClose={handleClose}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500
				}}
			>
				<Fade in={open}>
					<Swiper
						spaceBetween={3}
						slidesPerView={1}
						navigation
						pagination={{ clickable: true, type: 'progressbar' }}
						// scrollbar={{ draggable: true }}
						onSlideChange={() => console.log('slide change')}
						onSwiper={(swiper) => console.log(swiper)}
						loop={true}
						effect="fade"
					>
						{images.map((image, i) => (
							<SwiperSlide key={i}>
								<img src={image} className="w-100" />
							</SwiperSlide>
						))}
					</Swiper>
				</Fade>
			</Modal>
		</div>
	);
};
export default PortfolioModal;
